// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { FileKind } from "../../../define/FileKind";
import { GeneralKind } from "../../../define/GeneralKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;


const c_select = ['A','B','C','D'];
@ccclass
export default class ExamLayer extends BasePopUpLayer {

	@property({ type: cc.Button, displayName:'' })
	btnCommit: cc.Button = null;
	@property({ type: cc.Node, displayName:'' })
	btnAnew: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	itemNode: cc.Node = null;

	@property({ type: cc.Layout, displayName:'' })
	nodeExamList: cc.Layout = null;

	@property({ type: cc.Node, displayName:'' })
	nodeToggle: cc.Node = null;

    @property(cc.Node)
    nodeAd: cc.Node = null;

    @property(cc.Node)
    nodeBtn: cc.Node = null;

    @property(cc.Node)
    nodeResult: cc.Node = null;
    @property(cc.Node)
    nodeLose: cc.Node = null;
    @property(cc.Node)
    btnClose: cc.Node = null;

	// @property({ type: cc.Node, displayName:'' })
	// sprBg: cc.Node = null;
    
    private csvInfo: any = null;
    /** 题库id */
    private qBankId: string[] = [];
    /**  */
    // private bgSpaceY = 0;

    private checkArr: cc.ToggleContainer[]= [];
    
    start () {
        // this.bgSpaceY = this.sprBg.height - this.nodeExamList.node.height;
        this.itemNode.active = false;
        this.nodeToggle.active = false;
        this.btnCommit.interactable = false;

        let csvName = CsvFileKind.CsvFile.EXAM_QUESTION_BANK;
        this.csvInfo = CsvDataManage.instance.getCsvData(csvName);
        if (!this.csvInfo) {
            console.error(`数据未找到`);
            return;
        }
        
        O1HD.getModules().uiControlModule.hideLoading();
        this.resetData();

        // NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.EXAM_LAYER);
        utilsView.enterLayerDispose(UIKind.UILayerTag.EXAM, this.node);
    }

    // protected onDestroy(): void {
    //     O1HD.emit("normalMode.onBackNormal", UIKind.UILayerTag.EXAM_LAYER);
    // }

    initData() {
        this.qBankId = CsvDataManage.instance.getCsvRandomIdArr(CsvFileKind.CsvFile.EXAM_QUESTION_BANK, 5);
    }

    resetData() {
        this.nodeResult.active = false;
        this.nodeLose.active = false;
        this.btnClose.active = true;
        this.nodeBtn.active = true;
        this.nodeAd.active = true;

        this.btnCommit.node.active = true;
        this.btnAnew.active = false;

        this.initData();
        this.initLayer();
    }

    initLayer() {
        let title = this.csvInfo.title;
        this.nodeExamList.node.removeAllChildren();
        this.checkArr = [];
        for (let o of this.qBankId) {
            let info = this.csvInfo[o];
            let idx = this.checkArr.length;

            let itemNode = cc.instantiate(this.itemNode);
            itemNode.active = true;
            // itemNode.x = 0;
            this.nodeExamList.node.addChild(itemNode);
            
            let labelTopic = cc.find('labelTopic', itemNode).getComponent(cc.Label);            
            labelTopic.string = (idx+1) + '.' + info[title.desc];
            utilsView.refreshLabelUI(labelTopic);

            let nodeSelectCharge = cc.find('nodeSelectCharge', itemNode);
            this.checkArr.push(nodeSelectCharge.getComponent(cc.ToggleContainer));
            let tabsArr = utilsModel.splitLineFeed(info[title.items]);
            for (let j = 0; j < tabsArr.length; j++) {
                
                let nodeToggle = cc.instantiate(this.nodeToggle);
                nodeToggle.active = true;
                nodeSelectCharge.addChild(nodeToggle);

                let toggle = nodeToggle.getComponent(cc.Toggle);
                toggle.uncheck();
                // toggle.checkEvents[0].customEventData = '' + idx;

                let label = cc.find('labelName', nodeToggle).getComponent(cc.Label);
                label.string = c_select[j] + '.' + tabsArr[j];
                // utilsView.refreshLabelUI(label);
                nodeSelectCharge.getComponent(cc.Layout).updateLayout();
            }
            itemNode.getComponent(cc.Layout).updateLayout();
        }

        // this.nodeExamList.updateLayout();
        // this.sprBg.height = this.nodeExamList.node.height + this.bgSpaceY;
    }

    onClickCommit() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.showResultProgress();
        this.checkArr.forEach((cv)=> {
            cv.toggleItems.forEach((v, index)=> {
                v.interactable = false;
            });
        });
    }

    showResultProgress() {
        this.nodeAd.active = false;
        this.nodeBtn.active = false;

        this.nodeResult.active = true;

        let dtime = 0.2;
        let resultAni = this.nodeResult.getChildByName('resultAni');
        resultAni.scaleY = 0;
        cc.tween(resultAni)
            .to(dtime, {scaleY: 1}, {easing: 'sineIn'})
            .start();

        resultAni.children.forEach((v, i)=> {
            v.opacity = 0;
            cc.tween(v)
            .delay(dtime + 0.1 + i*0.2)
            .to(0.1, {opacity: 255})
            .start();
        });

        cc.tween(this.node)
        .delay(1.2)
        .call(()=> {
            if (this.node && cc.isValid(this.node)) {
                this.showResult();
            }
        })
        .start();
    }

    showResult() {
        // let bWin = true;
        let winCount = 0;
        let title = this.csvInfo.title;
        this.checkArr.forEach((v, i)=> {
            for (let j = 0; j < v.toggleItems.length; j++) {
                let o = v.toggleItems[j];
                if (o.isChecked) {
                    let info = this.csvInfo[this.qBankId[i]];
                    if (info[title.answer] == (j+1)) {
                        // bWin = false;
                        winCount++;
                    }
                    break;
                }
            }
        });

        if (winCount >= 4) {
            this.showWin();
        } else {
            this.showLose();
        }
        // let strText = bWin ? csvArr[0][title.correct_hint] : csvArr[0][title.error_hint];
        // O1HD.getModules().uiControlModule.showMessageBox(strText);
    }

    showWin() {
        this.emitExit();
        // NormalGameManager._instance.promoteLevel();
        NormalGameManager._instance.addExp(GeneralKind.GeneralValue.EXAM_SUCCESS_ADD_EXP);
        this.destroyNode();
    }

    showLose() {
        this.nodeResult.active = false;
        this.nodeLose.active = true;
        this.btnClose.active = true;
        this.nodeBtn.active = true;
        this.nodeAd.active = false;

        this.btnCommit.node.active = false;
        this.btnAnew.active = true;
    }

    onClickToggleContainer(event, data) {
        
    }

    onClickToggle(toggle: cc.Toggle, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let selectNum = 0;
        this.checkArr.forEach((v)=> {
            for (let o of v.toggleItems) {
                if (o.isChecked) {
                    selectNum++;
                    break;
                }
            }
        });

        this.btnCommit.interactable = selectNum >= this.checkArr.length;
    }

    onClickAd() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.showAnswer();
            this.nodeAd.active = false;
        },()=>{

        },null,"考试看广告获得答案");
    }

    showAnswer() {
        let title = this.csvInfo.title;
        for (let i = 0; i < this.qBankId.length; i++) {
            let o = this.qBankId[i];
            let info = this.csvInfo[o];
            // let idx = .length;
            let idx = Number(info[title.answer]);
            this.checkArr[i].toggleItems.forEach((v, index)=> {
                idx == (index+1) ? v.check() : v.uncheck();
                v.interactable = false;
            });
        }
        this.btnCommit.interactable = true;
    }

    onClickAnew() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.resetData();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
        this.emitExit();
    }

    emitExit() {
        O1HD.emit("normalMode.onBackNormal", UIKind.UILayerTag.EXAM);
        // O1HD.emit("normalMode.onBackNormal", UIKind.UILayerTag.EXAM_LAYER);
    }

    // update (dt) {}
}
